import { FC, ReactNode } from 'react';

import { useTranslation } from 'react-i18next';

import { TableRow } from '@components';
import { Source } from '@store';
import { composeClassName } from '@utilities';

import { ContentMapperFunctions } from './types';

import styles from './index.module.scss';

type Props<T = Source> = {
	data: T[];
	header: ReactNode;
	contentMappers: ContentMapperFunctions<T>;
	selected: number;
	className: string;
	rowTestId: string;
	renderDetails: (data: Source) => ReactNode;
};

export const Table: FC<Readonly<Props>> = ({
	data,
	header,
	contentMappers,
	selected,
	className,
	rowTestId,
	renderDetails
}) => {
	const { t } = useTranslation();

	return (
		<div className={composeClassName(styles.table, className)}>
			<header className={styles.header} data-testid="table-header">
				<div className={styles.row}>{header}</div>
			</header>

			<div className={styles.body} data-testid="table-body">
				{data.length === 0 ? (
					<div className={styles.empty} data-testid="table-empty">
						<p>{t('No results match your criteria. Please try different keywords.')}</p>
					</div>
				) : (
					data.map((item, index) => (
						<TableRow
							key={item.id}
							data={item}
							testId={rowTestId}
							contentMappers={contentMappers}
							renderDetails={renderDetails}
							selected={selected === index}
						/>
					))
				)}
			</div>
		</div>
	);
};

export default Table;
